<template>
  <form class="form-horizontal" @submit.prevent="login">
    <div class="form-group">
      <label for="email" class="control-label">
        {{ $t('label.email') }}
      </label>
      <input
        id="email"
        ref="loginInput"
        type="email"
        class="form-control"
        :placeholder="$t('placeholder.account.email')"
        :data-error-message="$t('label.email_rules')"
        required
        @input="handleInput"
      >
      <span v-if="errors.login" class="error-message active">
        {{ errors.login }}
      </span>
    </div>
    <div class="form-group">
      <!-- One Time Code (Temporary Code) -->
      <input
        v-if="oneTimeCodeRequested"
        id="password"
        key="pswd-1"
        v-model="password"
        type="text"
        autocomplete="off"
        class="form-control"
        :placeholder="$t('placeholder.account.password')"
        required
        @input="errors.password = ''"
      >

      <!-- Password -->
      <input
        v-else
        id="password"
        key="pswd-2"
        v-model="password"
        type="password"
        name="password"
        autocomplete="password"
        class="form-control"
        :placeholder="$t('placeholder.account.password')"
        required
        @input="errors.password = ''"
      >
      <span v-if="errors.password" class="error-message active">
        {{ errors.password }}
      </span>
    </div>
    <div v-if="countdown" class="form-group">
      <div :class="`alert alert-${alertStatus}`">
        <template v-if="alertStatus === 'success'">
          {{ oneTimeCodeSentText }}
          <div class="small">
            {{ $t('notice.temporary_password_sent.wait', formattedCountdown) }}
          </div>
        </template>
        <template v-else>
          {{ $t('error.too_many_requests.text') }}
          <div class="small">
            {{ $t('error.too_many_requests.wait', formattedCountdown) }}
          </div>
        </template>
      </div>
    </div>
    <div class="text-center">
      <div class="form-group">
        <button
          type="submit"
          class="btn btn-yellow btn-block"
          :disabled="isDisabledSignIn"
        >
          {{ $t('label.sign_in') }}
        </button>
      </div>
    </div>
    <div class="form-group">
      <button
        type="button"
        class="btn btn-link"
        :disabled="!!countdown"
        @click="getVerificationCode"
      >
        {{ $t('button.get_temporary_password') }}
      </button>
    </div>
  </form>
</template>

<script>
  const apiEndpoint = '/api/account';
  const defaultCountdown = 90;
  let iCountdown;

  export default {
    data () {
      return {
        email: '',
        password: '',
        oneTimeCodeRequested: false,
        oneTimeCodeSentText: '',
        countdown: 0,
        loginWithEmail: true,
        alertStatus: 'success',
        loginThrottled: false,
        errors: {
          login: '',
          password: '',
        },
      };
    },
    computed: {
      isDisabledSignIn () {
        return !!this.errors.login || !!this.errors.password || this.loginThrottled;
      },
      formattedCountdown () {
        if (this.countdown < 60) return { period: this.$tc('label.seconds', this.countdown, [this.countdown]) };
        return { period: moment.duration(this.countdown, 'seconds').humanize() };
      },
    },
    methods: {
      login () {
        $.post(`${apiEndpoint}/login`, {
          email: this.$refs.loginInput.value,
          password: this.password,
        })
          .then(({ result, data }) => {
            if (result === 'success') {
              window.location.href = data.redirect_url;
            }
          })
          .catch(response => this.handleError(response, true));
      },
      getVerificationCode () {
        $.post(`${apiEndpoint}/request_verification_code`, {
          email: this.$refs.loginInput.value,
        })
          .then(({ result }) => {
            if (result === 'success') {
              this.password = '';
              this.oneTimeCodeRequested = true;
              this.oneTimeCodeSentText = this.$t(
                'notice.temporary_password_sent.email',
                { minutes: this.$store.state.configs.verification_code_expiration },
              );
              this.startCountdown();
            }
          })
          .catch(response => this.handleError(response, false));
      },
      startCountdown () {
        if (!this.countdown) this.countdown = defaultCountdown;
        clearInterval(iCountdown);

        iCountdown = setInterval(() => {
          this.countdown -= 1;
          if (this.countdown <= 0) {
            this.alertStatus = 'success';
            this.loginThrottled = false;
            clearInterval(iCountdown);
          }
        }, 1000);
      },
      handleError ({ status, responseJSON, getResponseHeader }, isLogin) {
        if (status === 429) {
          this.alertStatus = 'danger';
          this.loginThrottled = isLogin;
          this.countdown = parseInt(getResponseHeader('Retry-After'));
          this.startCountdown();
        } else if (responseJSON) {
          const { type, details } = responseJSON.error;
          const error = type === 'bad_credentials' && isLogin ? 'password' : 'login';
          this.errors[error] = details;
        }
      },
      handleInput () {
        this.errors.login = '';
        this.errors.password = '';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .alert {
    margin: 0;
  }
  .error-msg, .valid-msg {
    margin-top: 10px;
  }
</style>
